import { clearEmployeeImersonate } from "../../app/impersonate-service";
import { signOut } from "../../utils/oidc-auth-service";

const storageKey = "wise_signoutTime";

const buildNavigationUrl = (navigation, level = "term") => {
  const {
    area,
    region,
    coordinator,
    program,
    year,
    term,
    isAddYear = false,
  } = navigation;

  if (!area) {
    return "/";
  }
  let url = `/areas/${area.id}`;
  if (level === "area") {
    return url;
  }
  if (region) {
    url = `${url}/regions/${region.id}`;
  } else {
    url = `${url}/regions/na`;
  }
  if (level === "region") {
    return url;
  }
  if (coordinator) {
    url = `${url}/coordinators/${coordinator.id}`;
  } else {
    url = `${url}/coordinators/na`;
  }
  if (level === "coordinator") {
    return url;
  }
  if (program) {
    url = `${url}/programs/${program.id}`;
  }
  if (level === "program")
  {
    return url;
  }
  if (isAddYear) {
    //we had to take /years out of the route for some resolution trickiness if I recall
    url = `${url}/addyear`;
    return url;
  }
  if (year) {
    url = `${url}/years/${year.id}`;
  }
  if (level === "year") {
    return url;
  }
  if (term) {
    url = `${url}/terms/${term.id}`;
  }
  return url;
};

const buildYearTermQueryString = (navigation = {}) => {
  const yearId = navigation?.year?.id;
  const termId = navigation?.term?.id;
  const pairs = [];

  if (yearId) {
    pairs.push(`yearId=${yearId}`);
  }
  if (termId) {
    pairs.push(`termId=${termId}`);
  }

  return pairs.length > 0 ? `?${pairs.join("&")}` : "";
};

const buildNavigationQueryString = (navigation) => {
  const {area = {},region = {},coordinator = {},program = {},year = {},term = {}} = navigation ?? {};
  const parameters = {
    areaId:area?.id,
    regionId:region?.id,
    coordinatorId:coordinator?.id,
    programId:program?.id,
    yearId:year?.id,
    termId:term?.id
  };
  let pairs = [];
  for (let p in parameters) {
    if (parameters[p]) {
      pairs.push(`${p}=${parameters[p]}`)
    }
  };
  const query = pairs.length === 0 ? "" : pairs.reduce((prev,current,index) => {
    return index === 0 ? current : `${prev}&${current}`;
  },"");
  return query;
}

const logOut = () => {
  //because our signout intermittently leaves them in the site needing to refresh, we put a timestamp in storage
  window.localStorage.setItem(storageKey, Date.now());
  clearEmployeeImersonate();
  signOut().catch(() => {
    window.location = "/logout";
  });
}

const urlRoutingService = (routerNavigate) => {
  const redirectToNavigation = (navigation) => {
    const url = buildNavigationUrl(navigation);
    routerNavigate(url);

  }
  const home = () => {
    routerNavigate("/");
  }
  const userAlerts = (navigation) => {
    const query = buildNavigationQueryString(navigation);
    routerNavigate(`/user-alerts?${query}`)
  }
  const help = ()  => {
    window.open('https://si-help.churchofjesuschrist.org/hc/en-us/categories/26148149831565-Tools-Applications', "_blank", "noopener,noreferrer");
  }
  const admin = () => {
    routerNavigate("/admin/system-alerts");
  }

  return {
    redirectToNavigation,
    logOut,
    userAlerts,
    help,
    home,
    admin,
    buildNavigationUrl
  }

}

export {buildNavigationUrl, buildYearTermQueryString, logOut, storageKey}
export default urlRoutingService;
